import React from 'react';
import { Button } from 'grommet';

const styles = { color: '#fff' };

export default ({ ...props }) => {
  return <Button primary {...props} style={styles} />;
};
